import React from 'react';

export function IconEmail(props: any) {
  return (
    <svg width="24" height="24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.174 5.219h13.121c1.183 0 2.175.992 2.136 2.174v9.27a2.198 2.198 0 01-2.174 2.174H5.175A2.198 2.198 0 013 16.663V7.394c0-1.182.991-2.175 2.174-2.175zm13.657 12.55c.305 0 .533-.19.533-.534V6.86a.521.521 0 00-.534-.535H4.642a.522.522 0 00-.534.535V17.26a.522.522 0 00.534.509h14.19z"
        fill="#000"
        fillOpacity=".54"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.81 8.613l-4.691 3.93c-.23.228-.534.228-.801 0l-4.693-3.93c-.229-.152-.534-.152-.725.039-.228.228-.228.61.039.8l5.302 4.425a.803.803 0 00.991 0l5.303-4.424c.228-.23.267-.611.037-.801a.63.63 0 00-.763-.039z"
        fill="#000"
        fillOpacity=".54"
      />
    </svg>
  );
}
